<template>
    <div :data-uuid="settings.uuid" class="custom-block" :style="blockStyle()">
        <div :style="collapseStyle" v-if="settings.general.allowCollapse" class="collapse-handler">
            <button :style="buttonStyle" @click="handleCollapse">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M5.83331 8.3335L9.99998 12.5002L14.1666 8.3335"
                        :stroke="settings.general.handlerColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </button>
        </div>
        <slot></slot>
    </div>
</template>

<script>
import {
    allEvents,
    containerBlock,
    noneEvents,
    resolveBackground,
    resolveMargin,
    resolvePadding,
    typedHeight,
    typedWidth
} from "../utils/style"
import ViewMixin from "../utils/view-mixin"

export default {
    props: {
        settings: {
            type: Object,
            default: () => {}
        }
    },
    mixins: [ViewMixin],
    name: "WidgetCustomBlock",
    data() {
        return {
            collapsed: false
        }
    },
    computed: {
        desktop() {
            return this.settings.desktop
        },
        mobile() {
            return this.settings.mobile
        },
        general() {
            return this.settings.general
        },
        collapseStyle() {
            return {
                textAlign: "end",
                background: this.collapsed ? "transparent" : this.settings.general.handlerBackground,
                width: this.settings.general.width.value + this.settings.general.width.type,
                padding: this.collapsed ? "0" : "5px 0"
            }
        },
        buttonStyle() {
            return {
                padding: "0 10px",
                background: !this.collapsed ? "transparent" : this.settings.general.handlerBackground,
                transform: this.collapsed ? "rotate(180deg)" : "none"
            }
        },
        containerStyle() {
            return {
                ...containerBlock(),
                ...noneEvents(),
                ...this.resolveStyle(
                    {
                        alignItems: this.desktop.align,
                        justifyContent: this.desktop.justify,
                        ...resolvePadding(this.desktop.margin)
                    },
                    {
                        alignItems: this.mobile.align,
                        justifyContent: this.mobile.justify,
                        ...resolvePadding(this.mobile.margin)
                    }
                )
            }
        }
    },
    methods: {
        blockStyle() {
            let style = {
                display: "flex",

                ...resolveBackground(this.settings.background),
                ...allEvents(),
                ...typedWidth(this.general.width),
                ...this.resolveStyle(
                    {
                        flexDirection: this.general.isRow ? "row" : "column",
                        alignItems: !this.general.isRow ? this.desktop.justify : this.desktop.align,
                        justifyContent: !this.general.isRow ? this.desktop.align : this.desktop.justify,
                        ...resolveMargin(this.desktop.margin),
                        ...resolvePadding(this.desktop.padding)
                    },
                    {
                        flexDirection: this.mobile.isRow ? "row" : "column",
                        alignItems: this.mobile.justify,
                        justifyContent: this.mobile.align,
                        ...resolveMargin(this.mobile.margin),
                        ...resolvePadding(this.mobile.padding)
                    }
                )
            }

            if (this.general.height) {
                if (!this.collapsed) {
                    style = { ...style, ...typedHeight(this.general.height) }
                } else {
                    style = { ...style, minHeight: 0 }
                }
            }

            return style
        },
        handleCollapse() {
            const children = Array.from(this.$el.children).filter(
                child => !child.classList.contains("collapse-handler")
            )
            for (const child of children) {
                if (!this.collapsed) {
                    child.setAttribute("data-display", window.getComputedStyle(child, null).getPropertyValue("display"))
                    child.style.display = "none"
                } else {
                    child.style.display = child.dataset.display || "flex"
                }
            }
            this.collapsed = !this.collapsed
        }
    }
}
</script>
